( function () {
	'use strict';

	function DeleteScheduleModal ( logger, $modalInstance, eventModel, scheduleservice ) {
		var self   = this;

		self.title = 'Delete Schedule';

		function deleteSchedHandler () {
			self.loading = true;

			scheduleservice.deleteSchedule( eventModel )
				.then( function () {
					logger.notifySuccess( 'Successfully deleted.', 'Schedule' );
				}, function () {
					logger.notifyError( 'An error occurred. Please try again later.', '' );
				} )
				.finally( function () {
					$modalInstance.close();
				} );
		}

		function closeModal () {
			$modalInstance.dismiss();
		}

		function activate () {
			logger.info( 'Activated Delete Schedule Modal View' );
		}

		activate();

		self.deleteSchedHandler = deleteSchedHandler;
		self.closeModal         = closeModal;
	}

	angular
		.module( 'app.schedules' )
		.controller( 'DeleteScheduleModal', DeleteScheduleModal );

	DeleteScheduleModal.$inject = [ 'logger', '$modalInstance', 'eventModel', 'scheduleservice' ];
} )( );
